<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.userpermission') }} > {{ employee.username }}
      </BaseTopBarContent>
      <BaseTopBarContent className="right">
        <div
          v-if="!loading"
          class="action">
          <BaseActionDropdown
            :icon="`fas fa-cog`"
            :text="$t('button.options')"
            :items="[
              {
                icon: 'fas fa-trash',
                iconClassName: 'text-danger',
                text: $t('button.delete'),
                textClassName: 'text-danger',
                value: 'delete',
              }
            ]"
            @onSelect="handleSelectOption"
          />
        </div>
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <UserPermissionForm
        :state="employee"
        :appRolePermissions="appRolePermissions"
        :rolePermissionList="rolePermissionList"
        :isSubmitted="isSubmitted"
        :disabled="disabled"
        :form.sync="form"
        @onSubmit="handleSubmit"
      />

      <baseConfirmDeleteModal
        :show="modal.show"
        :loading="modal.loading"
        @onClose="handleCloseModal"
        @onCancel="handleCancleModal"
        @onSubmit="handleSumitModal"
      />
      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { USER_PERMISSION_TYPE } from '@/helpers/enum'
import sidebarModule from './../../sidebarModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      loading: true,
      isSubmitted: false,
      disabled: false,
      query: {
        id: this.$route.query.id,
        username: this.$route.query.username,
      },
      modal: {
        show: false,
        loading: false,
      },
      form: null,
    }
  },

  computed: {
    ...mapState('appPermission', {
      appRolePermissions: 'permissionList',
    }),
    ...mapState('rolePermission', {
      rolePermissionList: 'rolePermissionList',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
      employee: 'getEmployee',
    }),
  },

  created () {
    this.fetchData()
  },

  beforeMount () {
    this.initPage({
      section: 'app',
      name: this.$t('app.settings.title'),
      current: {
        app_name: 'settings',
        app_id: null,
      },
    })
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.query.username,
      'router': {
        'name': 'SettingsUserEdit',
        'query': {
          id: this.query.id,
          username: this.query.username,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 2,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions('appPermission', {
      getAppPermissionList: 'getAppPermissionList',
    }),
    ...mapActions('rolePermission', {
      getRolePermissionList: 'getRolePermissionList',
    }),
    ...mapActions({
      getEmployee: 'getEmployee',
      updateEmployee: 'updateEmployee',
      deleteEmployee: 'deleteEmployee',
    }),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.getEmployee({ emp_id: this.query.id }),
        this.getAppPermissionList(),
        this.getRolePermissionList(),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    getDataForm (input = {}) {
      let data = {
        'user_id': this.employee.user_id,
        'emp_id': this.employee.emp_id,
        'permission_type': input.type,
      }
      if (input.type === USER_PERMISSION_TYPE.GENERAL) {
        data.permissions = input.permissions
      } else if (input.type === USER_PERMISSION_TYPE.RELATIONAL) {
        data.permission_ids = input.permissionIds
      }
      return data
    },
    async handleSubmit (input = {}) {
      this.isSubmitted = true
      this.disabled = true
      const data = this.getDataForm(input)
      const response = await this.updateEmployee(data)
      if (response.success) {
        this.isSubmitted = false
        this.disabled = false
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.employee.username }),
          color: 'success',
          icon: 'cloud',
        })
        this.fetchData()
      }
    },
    handleSelectOption (value) {
      if (value === 'delete') {
        this.onOpenModal()
      }
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.modal.show = false
    },
    handleCancleModal () {
      this.modal.show = false
    },
    async handleSumitModal () {
      this.modal.loading = true
      const response = await this.deleteEmployee({
        user_id: this.employee.user_id,
        emp_id: this.query.id,
      })
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.employee.username }),
          color: 'danger',
          icon: 'delete',
        })
        this.modal.loading = false
        this.modal.show = false
        this.$router.push({ name: 'SettingsUserList' })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/settings/user/Edit.vue